<div class="search-tool-container" *ngIf="!isLoadingSearchtool && !isLoadingLabels && !notFound">
	<div class="filter-col">
		<div class="block">
			<div class="title">
				{{ labels.lbl_resultados_encontrados }}
				{{
					(itemsPerType['kb'] ? itemsPerType['kb'] : 0) +
						(itemsPerType['cmdb'] ? itemsPerType['cmdb'] : 0) +
						(itemsPerType['request'] ? itemsPerType['request'] : 0)
				}}
			</div>
			<div class="list">
				<div
					[ngClass]="{ selected: selectedSearchType === 'kb' }"
					(click)="sortedBy = 'id'; sortDown = false; selectedSearchType = 'kb'; selectedPage = 1; search(0, 'kb')"
					*ngIf="itemsPerType['kb']">
					<span>KB</span>
					<span>
						{{
							itemsPerType['kb'] <= 9
								? '00' + itemsPerType['kb']
								: itemsPerType['kb'] <= 99
									? '0' + itemsPerType['kb']
									: itemsPerType['kb']
						}}
					</span>
				</div>
				<div
					[ngClass]="{ selected: selectedSearchType === 'cmdb' }"
					(click)="sortedBy = 'id'; sortDown = false; selectedSearchType = 'cmdb'; selectedPage = 1; search(0, 'cmdb')"
					*ngIf="itemsPerType['cmdb'] > 0">
					<span>CMDB</span>
					<span>
						{{
							itemsPerType['cmdb'] <= 9
								? '00' + itemsPerType['cmdb']
								: itemsPerType['cmdb'] <= 99
									? '0' + itemsPerType['cmdb']
									: itemsPerType['cmdb']
						}}
					</span>
				</div>
				<div
					[ngClass]="{ selected: selectedSearchType === 'request' }"
					(click)="sortedBy = 'id'; sortDown = false; selectedSearchType = 'request'; selectedPage = 1; search(0, 'request')"
					*ngIf="itemsPerType['request'] > 0">
					<span>{{ labels.lbl_geral_chamado }}</span>
					<span>
						{{
							itemsPerType['request'] <= 9
								? '00' + itemsPerType['request']
								: itemsPerType['request'] <= 99
									? '0' + itemsPerType['request']
									: itemsPerType['request']
						}}
					</span>
				</div>
			</div>
		</div>
	</div>

	<div class="search-list-container">
		<div class="search-text">
			<span><fa-icon [icon]="icons.faSearch"></fa-icon></span>
			<span>{{ labels.lbl_here_some_results_for }} {{ searchText.length > 99 ? searchText.slice(0, 98) + '..' : searchText }}</span>
		</div>
		<cpi-msp-table
			[header]="this[selectedSearchType + 'Header']"
			[height]="'60dvh'"
			[body]="searchI[selectedSearchType]"
			[isLoading]="isLoadingNextPage"
			[itemRouterLink]="routerLinkType[selectedSearchType]"
			[insidePagination]="false"
			[tableOnly]="true"
			(getSort)="sortedBy = $event['sortBy']; sortDown = $event['sortDown']; search(0, selectedSearchType)">
		</cpi-msp-table>
		<cpi-pagination-counter
			[arrayLength]="itemsPerType[selectedSearchType]"
			[setCurrentPage]="selectedPage"
			(getCurrentPage)="selectedPage = $event; search(selectedPage - 1, selectedSearchType)"
			*ngIf="itemsPerType[selectedSearchType] && itemsPerType[selectedSearchType] != 0">
		</cpi-pagination-counter>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingSearchtool || isLoadingLabels || notFound">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ notFound ? labels.lbl_security_nenhum_registro : labels.lbl_procurando_arquivos }}!</div>
</div>
